import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import { switchSiteTheme } from 'Redux/ducks/site-theme';

const ThemeToggle = ({ siteTheme, place, siteBrand }) => {
  const isLight = siteTheme === 'light';

  if (siteBrand !== 'fanatical') return false;

  return (
    <Button
      color="link"
      className="theme-toogle-container"
      onClick={() => switchSiteTheme(isLight ? 'dark' : 'light', place, 'button')}
    >
      <div className="d-flex">
        <div className="icon-container">
          <FontAwesomeIcon icon={faLightbulb} />
        </div>
        <div className="text-container">
          {!isLight &&
            <FormattedMessage id="theme-toggle.lighttheme" defaultMessage="Light Theme" />
          }
          {isLight &&
            <FormattedMessage id="theme-toggle.darktheme" defaultMessage="Dark Theme" />
          }
        </div>
      </div>
    </Button>
  );
};


ThemeToggle.propTypes = {
  siteTheme: PropTypes.string,
  place: PropTypes.string,
};

ThemeToggle.defaultProps = {
  siteTheme: '',
  place: '',
};

const mapStateToProps = ({
  siteTheme,
  siteBrand,
}) => ({
  siteTheme,
  siteBrand,
});


export default connect(mapStateToProps)(ThemeToggle);
